import {
  CREATE_DEFAULT_BUTTON_SUCCESS,
  CREATE_DEFAULT_BUTTON_ERROR,
  EMAIL_CONFIRM_RESEND,
  EMAIL_SEND_SUCCESS,
  EMAIL_SEND_ERROR,
  CHECK_EMAIL_CONFIRMED_RESPONSE,
  CHECK_EMAIL_CONFIRMED_ERROR,
  CHECK_EMAIL_CONFIRMED,
  SET_VERIFY_EMAIL_MODAL_OPEN,
  UPDATE_MESSAGE,
  UPDATE_STEP,
  EMAIL_SEND_SUCCESS_RESET,
  CREATE_DEFAULT_BUTTON,
  TOGGLE_ADD_VOUCHER,
  UPDATE_VOUCHER_DETAILS,
  UPDATE_VOUCHER_ZIPCODE,
  UPDATE_AGREEMENT,
  ADD_MERCHANT_FOOTER,
  UPDATE_SELECTED_VOUCHER_TYPE,
} from './actionsPartner';
import { getHost } from '../../utilsV3/helpers';
import { getParameterByName } from '../../../utility/queryStringHelper';
import { isGmbFlow } from './utils/partnerUtils';
import {
  VOUCHER_TYPE_CUSTOM,
  VOUCHER_TYPE_PERCENTAGE,
  ALL_VOUCHER_TYPE_INFO,
} from './utils/voucherConstants';

const bnCode = (getParameterByName('bn') || '').toLowerCase();
const showVoucherFlow = !isGmbFlow(bnCode);

const initialState = {
  step: 0,
  message: '',
  addVoucher: false,
  selectedVoucherType: VOUCHER_TYPE_PERCENTAGE,
  allVoucherTypeInfo: ALL_VOUCHER_TYPE_INFO,
  voucherInfo: {},
  showVoucherFlow,
  bnCode,
};

export default function partnerButtons(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_DEFAULT_BUTTON_SUCCESS: {
      const buttonId = action.payload.id;
      const offerProgramId = action.payload.offerProgramId;
      const offerProgramCode = action.payload.offerProgramCode;
      const shortUrl = `${getHost()}/biz/fund?id=${buttonId}`;
      return {
        ...state,
        shortUrl,
        id: buttonId,
        offerProgramId,
        offerProgramCode,
        step: 2,
        isSending: false,
        error: '',
      };
    }
    case CREATE_DEFAULT_BUTTON_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
      };
    }
    case CREATE_DEFAULT_BUTTON: {
      return {
        ...state,
        isSending: true,
      };
    }
    case EMAIL_CONFIRM_RESEND: {
      return {
        ...state,
        isSending: true,
      };
    }
    case EMAIL_SEND_SUCCESS: {
      return {
        ...state,
        isSending: false,
        confirmEmailSent: true,
      };
    }
    case EMAIL_SEND_SUCCESS_RESET: {
      return {
        ...state,
        isSending: false,
        confirmEmailSent: false,
      };
    }
    case EMAIL_SEND_ERROR: {
      return {
        ...state,
        isSending: false,
        emailSendError: action.payload,
        verifyEmailModalOpen: false,
      };
    }
    case CHECK_EMAIL_CONFIRMED_RESPONSE: {
      return {
        ...state,
        verifyEmailModalOpen: false,
        isSending: false,
      };
    }
    case CHECK_EMAIL_CONFIRMED: {
      return {
        ...state,
        isSending: true,
      };
    }
    case SET_VERIFY_EMAIL_MODAL_OPEN: {
      return {
        ...state,
        verifyEmailModalOpen: true,
      };
    }
    case CHECK_EMAIL_CONFIRMED_ERROR: {
      return {
        ...state,
        checkIfEmailConfirmedError: true,
        isSending: false,
        verifyEmailModalOpen: false,
      };
    }

    case UPDATE_MESSAGE: {
      return {
        ...state,
        message: action.message,
      };
    }

    case UPDATE_STEP: {
      return {
        ...state,
        step: action.step,
      };
    }

    case TOGGLE_ADD_VOUCHER: {
      return {
        ...state,
        addVoucher: !state.addVoucher,
      };
    }

    case UPDATE_VOUCHER_DETAILS: {
      const { voucherType, voucherValue, voucherDetails, discountTagline } =
        action.payload;
      const allVoucherTypeInfo = [...state.allVoucherTypeInfo];
      const typeToUpdate = voucherType || state.selectedVoucherType;
      const voucherInfoIndexToUpdate = allVoucherTypeInfo.findIndex(
        (voucherInfo) => voucherInfo.type === typeToUpdate
      );
      const updatedVoucherInfo = allVoucherTypeInfo[voucherInfoIndexToUpdate];
      if (voucherValue !== undefined) {
        updatedVoucherInfo.value = voucherValue;
        updatedVoucherInfo.tagline =
          typeToUpdate === VOUCHER_TYPE_CUSTOM ? voucherValue : discountTagline;
      }

      if (voucherDetails !== undefined) {
        updatedVoucherInfo.details = voucherDetails;
      }

      allVoucherTypeInfo.splice(
        voucherInfoIndexToUpdate,
        1,
        updatedVoucherInfo
      );
      return {
        ...state,
        allVoucherTypeInfo,
      };
    }

    case UPDATE_SELECTED_VOUCHER_TYPE: {
      return {
        ...state,
        selectedVoucherType: action.voucherType,
      };
    }

    case UPDATE_VOUCHER_ZIPCODE: {
      return {
        ...state,
        voucherInfo: {
          ...state.voucherInfo,
          zipcode: action.zipcode,
        },
      };
    }

    case UPDATE_AGREEMENT: {
      return {
        ...state,
        voucherInfo: {
          ...state.voucherInfo,
          isOnAgreement: action.isOnAgreement,
        },
      };
    }

    case ADD_MERCHANT_FOOTER: {
      return {
        ...state,
        merchantFooter: action.merchantFooter,
      };
    }

    default:
      return state;
  }
}
